import { observer } from "mobx-react-lite";
import { LoginView } from "../view/loginView";

const Login = observer(
    function LoginRender(props) {        
        function toggleShowPasswordACB() {
            props.loginModel.togglePasswordVisible();
        }
        function loginRequestACB(email, password) {
            //login check!
            //send to next page
            window.location.hash = "#/input";
        }
        function signupRequestACB(email, password) {
            //Sign up (page?)
        }
        function onWriteEmailACB(text) {
            props.loginModel.setEmail(text);
        }
        function onWritePasswordACB(text) {
            props.loginModel.setPassword(text);
        }
        return (
            <LoginView
                showPassword={props.loginModel.showPassword}
                togglePasswordVisibleACB={toggleShowPasswordACB}
                sendLoginACB={loginRequestACB}
                sendSignupACB={signupRequestACB}
                writingChangedEmailACB={onWriteEmailACB}
                writingChangedPasswordACB={onWritePasswordACB}
                email={props.loginModel.email}
                password={props.loginModel.password}
            />
        );
    }
);

export { Login };